<template>
  <div class="container text--center spacing">
    <h1>App version: {{ appVersion }}</h1>
  </div>
</template>

<script>
  export default {
    name: "VersionInfo",
    computed: {
      appVersion: function () {
        return this.$store.getters.appVersion;
      }
    }
  }
</script>

<style scoped>

</style>
